import React from "react";
import { Sheet } from 'react-modal-sheet';
import { styled } from 'styled-components';
import CloseIcon from "../../assets/icons/close.svg";
import { FlexContainer } from "../styled";


const BottomSheetBackdrop = styled(Sheet.Backdrop)`
    background-color: rgba(0, 0, 0, 0.56) !important;
    backdrop-filter: blur(30px) !important;
    -webkit-backdrop-filter: blur(30px) !important;
`;
const BottomSheetContainer = styled(Sheet.Container)`
  background: #2828284D !important;
  border: 1px solid #7455BF !important;
  border-top-left-radius: 30px !important;
  border-top-right-radius: 30px !important;
  height: fit-content !important;
  min-height: 30vh !important;
  max-height: 90vh !important;
  box-shadow: 0px -13px 65px 0px rgba(116,85,191,0.51) !important;
  backdrop-filter: blur(50px) !important;
  -webkit-backdrop-filter: blur(50px) !important;
  max-width: 420px !important;
  margin: 0 auto !important;
  left:auto !important;
`
const BottomSheetHeader = styled(Sheet.Header)`
  display: flex;
  align-items: center;
  justify-content:center;
  height: 60px;
`
const BottomSheetTitle = styled.h2`
  font-size: 1.2em;
  font-weight: 700;
  color: ${(props) => props.theme.colors.text.light};
  margin: 0;
  text-shadow: 4px 4px 24px rgba(255, 255, 255, 0.34);
  
`;
const CloseButton = styled.button` 
  width: 32px;
  aspect-ratio: 1;
  position: absolute;
  right: 16px;
  top: 12px;
  background: transparent;
  cursor: pointer;
  z-index: 1;
  border: 1px solid #7455BF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 4px 4px 36px 3px rgba(116,85,191,0.84);
  padding: 5px;
  img{
    width:100%;
    opacity: 0.5;
  }
`;

const CustomBottomSheet = ({ open, onDismiss, children,title = null }) => {
  return (
    <>
      <Sheet isOpen={open} onClose={onDismiss}>
        <FlexContainer>
        <BottomSheetContainer>
        <BottomSheetHeader>
          {title && <BottomSheetTitle>{title}</BottomSheetTitle>}
          <CloseButton onClick={onDismiss}>
            <img src={CloseIcon} alt="Close" />
          </CloseButton>
        </BottomSheetHeader>
          <Sheet.Content>{children}</Sheet.Content>
        </BottomSheetContainer>
        </FlexContainer>
        <BottomSheetBackdrop />
      </Sheet>
    </>
  );
};

export default CustomBottomSheet;
